<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId">
    <div class="modal__content">
      <div class="modal__body">
        <div class="modal__section">
          <h1 data-test-id="authorize-ambassador-modal-header-title" class="modal__title">{{ convert('authorizedAmbassadorsModal.modalHeading') }}</h1>
          <div>
            <h5 data-test-id="authorize-ambassador-modal-ambassador-name">{{ ambassador?.name }}</h5>
            @if (ambassador?.email) {
              <h6 data-test-id="authorize-ambassador-modal-ambassador-email">{{ ambassador?.email }}</h6>
            }
            @if (ambassador?.name) {
              <h6 data-test-id="authorize-ambassador-modal-ambassador-phone">{{ ambassador?.phone ? reformatPhone(ambassador?.phone) : '' }}
              </h6>
            }
          </div>
          <div class="modal-close-container">
            <button
              data-test-id="authorize-ambassador-modal-header-close-button"
              id="close_x_button"
              class="modal__close-btn"
              [attr.aria-label]="convert('common.modalClose')"
              allytmln="modalClose"
              data-micromodal-close
              (click)="close()">
              <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
            </button>
          </div>

          <p data-test-id="authorize-ambassador-modal-body-paragraph" class="modal-paragraph">{{ convert('authorizedAmbassadorsModal.modalParagraph') }}</p>

          <div class="modal__actions mt-4 text-center">
            <button
              data-test-id="authorize-ambassador-modal-actions-authorize-button"
              class="btn btn-primary me-md-2 mb-3 mb-md-0"
              (click)="submit()"
              allytmln="modalAuthorize"
            >{{convert('authorizedAmbassadorsModal.authorizeBtn')}}</button>
          </div>
          <div class="modal__actions mt-4 text-center">
            <button
              data-test-id="authorize-ambassador-modal-actions-cancel-button"
              class="ms-lg-2 mt-3 mt-lg-0 btn btn-link"
              (click)="close()"
              allytmln="modalCancel"
            >{{convert('authorizedAmbassadorsModal.cancelBtn')}}</button>
          </div>
        </div>
      </div>
    </div>
  </app-modal>
</ng-container>
